"use strict";

import $ from "jquery";

$(document).on("turbolinks:load", function () {
  $("a.disabled").on("click", false);
});
